import convertApi from "./convertApi";
import { createSlice } from "@reduxjs/toolkit";
import { createThunkFromApi } from "store/utils";

export const getConvertAmountMax = createThunkFromApi(
  "convert/getConvertAmountMax",
  convertApi.getConvertAmountMax
);

export const convertInsertInitial = createThunkFromApi(
  "convert/convertInsertInitial",
  convertApi.convertInsertInitial
);

export const convertInsertConfirmedUser = createThunkFromApi(
  "convert/convertInsertConfirmedUser",
  convertApi.convertInsertConfirmedUser
);

export const getConvertInitial = createThunkFromApi(
  "convert/getConvertInitial",
  convertApi.getConvertInitial
);

const initialState = {
  convertInitial: null,
  convertAmountMax: null,
  convertInsertInitial: null,
  convertInsertConfirmedUser: null,
};

export const convertSlice = createSlice({
  name: "convert",
  initialState,

  reducers: {
    clearConvertInsertInitial(state) {
      state.convertInsertInitial = null;
    },
  },

  extraReducers: {
    [getConvertInitial.fulfilled]: (state, { payload }) => {
      state.convertInitial = payload.data;
    },

    [getConvertAmountMax.fulfilled]: (state, { payload }) => {
      state.convertAmountMax = payload.data;
    },

    [convertInsertInitial.fulfilled]: (state, { payload }) => {
      state.convertInsertInitial = payload.data;
    },

    [convertInsertConfirmedUser.fulfilled]: (state, { payload }) => {
      state.convertInsertConfirmedUser = payload.data;
    },
  },
});

export const { clearConvertInsertInitial } = convertSlice.actions;

export default convertSlice.reducer;
